<template>
    <div class="header">
        <div class="nav-wrap flex-row-center-between">
            <div class="logo" @click="$router.push('/')">
                <img src="../../assets/logo.svg" alt="">
            </div>
            <div class="header-nav flex-row-center">
                <el-menu :default-active="$route.path" class="el-menu-nav" mode="horizontal">
                    <template v-for="(item, index) in navList">
                        <!-- 只有 path 时，渲染一级菜单 -->
                        <el-menu-item v-if="item.path" :key="index" :index="item.path">
                            <span class="menu-item-span" slot="title"><router-link :to="item.path"><span
                                        class="title">{{ $t(item.title)
                                        }}</span></router-link></span>
                        </el-menu-item>

                        <!-- 有子菜单时，渲染二级菜单 -->
                        <el-submenu v-else :key="`${index}`" :index="'submenu-' + index">
                            <template slot="title">
                                <span class="title">{{ $t(item.title) }}</span>
                            </template>
                            <el-menu-item v-for="(subItem, subIndex) in item.children" :key="subIndex"
                                :index="subItem.path">
                                <router-link :to="subItem.path"><span class="title">{{ $t(subItem.title)
                                        }}</span></router-link>
                            </el-menu-item>
                        </el-submenu>
                    </template>
                </el-menu>
                <div class="lang-btn" v-show="showLangBtn">
                    <span :class="{ active: lang === 'zh' }" @click="changeLanguage('zh')">CN</span>
                    <span class="active">/</span>
                    <span :class="{ active: lang === 'en' }" @click="changeLanguage('en')">EN</span>
                </div>
            </div>
            <div class="header-nav-mobile">
                <el-button class="menu" type="text" @click="toggleNav">
                    <i>
                        <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="5" y="7" width="18" height="2" rx="1" fill="currentColor" />
                            <rect x="5" y="13" width="18" height="2" rx="1" fill="currentColor" />
                            <rect x="5" y="19" width="18" height="2" rx="1" fill="currentColor" />
                        </svg>
                    </i>
                </el-button>
                <el-drawer size="66%" class="drawer" :visible.sync="isOpen" :with-header="false">
                    <el-menu :default-active="$route.path" class="el-menu-nav">
                        <template v-for="(item, index) in navList">
                            <!-- 只有 path 时，渲染一级菜单 -->
                            <el-menu-item v-if="item.path" :key="index" :index="item.path">
                                <span class="menu-item-span" slot="title"><router-link :to="item.path"><span
                                            class="title">{{ $t(item.title)
                                            }}</span></router-link></span>
                            </el-menu-item>
                            <!-- 有子菜单时，渲染二级菜单 -->
                            <el-submenu v-else :key="`${index}`" :index="'submenu-' + index">
                                <template slot="title">
                                    <span class="title">{{ $t(item.title) }}</span>
                                </template>
                                <el-menu-item v-for="(subItem, subIndex) in item.children" :key="subIndex"
                                    :index="subItem.path">
                                    <router-link :to="subItem.path"><span class="title">{{ $t(subItem.title)
                                            }}</span></router-link>
                                </el-menu-item>
                            </el-submenu>
                        </template>
                    </el-menu>
                    <div class="lang-btn" v-show="showLangBtn">
                        <span :class="{ active: lang === 'zh' }" @click="changeLanguage('zh')">中文</span>
                        <span class="active">|</span>
                        <span :class="{ active: lang === 'en' }" @click="changeLanguage('en')">English</span>
                    </div>
                </el-drawer>
            </div>
        </div>
    </div>
</template>

<script>
import { loadLanguageAsync } from '../../i18n'

export default {
    name: "HeaderNav",
    data() {
        return {
            isOpen: false,
            showLangBtn: true,
            isAbout: false,
            isNews: false,
            navList: [
                {
                    title: 'nav.home',
                    path: '/home',
                },
                {
                    title: 'nav.about',
                    path: '/about',
                },
                {
                    title: 'nav.investment',
                    path: '/investment',
                },
                {
                    title: 'nav.products',
                    path: '/products',
                },
                {
                    title: 'nav.news',
                    path: '/news',
                },
                {
                    title: 'nav.strategic',
                    path: '/strategic',
                }
            ]
        }
    },
    watch: {
        "$route"(to, from) {
            this.isOpen = false;
        }
    },
    methods: {
        toggleNav() {
            this.isOpen = !this.isOpen;
        },
        toPage(path) {
            this.$router.push(path);
        },
        changeLanguage(lang) {
            this.isOpen = false;
            loadLanguageAsync(lang).then(() => {
                document.title = `${this.$i18n.t(this.$route.meta.title)}${lang === 'en' ? '-Fujian Fulv Lianxin Fund' : '-华闽联信基金'}`;
            });
        },
        isActive(children) {
            const pathList = children.map(item => item.path.substr(4));
            const currentPath = this.$route.path;
            for (let i = 0; i < pathList.length; i++) {
                if (currentPath.indexOf(pathList[i]) >= 0) {
                    return true;
                }
            }
            return false;
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale;
        }
    },
}
</script>

<style scoped lang="less">
.header {
    padding: 0.25rem 0;

    .nav-wrap {
        >.logo {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 4.4375rem;
                height: 3.13831rem;
                flex-shrink: 0;
            }   
        }

        .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
            background-color: var(--primary-color);
        }

        .el-menu-nav {
            border-bottom: none;

            .el-menu-item {
                border-bottom: none;
                padding: 0;

                span {
                    display: block;
                    height: 100%;
                    font-size: 1rem;
                    padding: 0 1.5rem;
                    border-bottom: none;
                    color: var(--default-text-color);
                }

                span.menu-item-span {
                    padding: 0;
                }
            }

            .el-menu-item.is-active {
                border-bottom: none;

                .title {
                    font-weight: bold;
                    color: var(--primary-color);

                }
            }

            /deep/ .el-submenu {
                .el-submenu__title {
                    padding: 0;
                    border-bottom: none;

                    span {
                        display: block;
                        height: 100%;
                        padding: 0 1.5rem;
                        font-size: 1rem;
                        color: var(--default-text-color);
                    }

                    .el-submenu__icon-arrow {
                        display: none;
                    }
                }
            }

            /deep/ .el-submenu.is-active {
                .el-submenu__title {
                    color: var(--primary-color);

                    .title {
                        font-weight: bold;
                    }
                }
            }
        }

        .lang-btn {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-left: 1rem;

            span {
                margin: 0 .25rem;

                &.active {
                    color: var(--primary-color);
                }
            }
        }
    }
}

.header .nav-wrap .header-nav-mobile {
    .menu {
      //  font-size: 2.6rem;
        padding: 0.75rem 0;
        color: var(--default-text-color);
    }

    .lang-btn {
        margin: 1rem 2rem 0 2rem;
        height: 3rem;
        width: calc(100% - 4rem);

        span {
            margin: 0 0.5rem;
        }
    }

    /deep/ .drawer {
        .el-submenu__icon-arrow {
            display: inline !important;
        }

        .el-menu-item,
        .el-submenu__title {
            //  padding-left: 1rem !important;
        }
    }
}

/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
    .header {
        padding: 0;

        .nav-wrap .el-menu-nav .el-submenu.is-active .el-submenu__title span {
            color: var(--primary-color);
        }
        .nav-wrap .el-menu-nav .el-menu-item span {
           font-size: 1.25rem;
        }
        .nav-wrap .el-menu-nav .el-menu-item.is-active .title {
            color: var(--primary-color);
        }
        .nav-wrap .header-nav-mobile .lang-btn span{
            font-size: 1.25rem;
            margin-left: 0.75rem;
        }
    }

    .header-nav {
        display: none;
    }
}

@media screen and (min-width: 768px) {
    .header-nav-mobile {
        display: none;
    }
}
</style>